import { render, staticRenderFns } from "./PromotionLoginModal.vue?vue&type=template&id=38e2199e&scoped=true&"
import script from "./PromotionLoginModal.vue?vue&type=script&lang=js&"
export * from "./PromotionLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./PromotionLoginModal.vue?vue&type=style&index=0&id=38e2199e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2199e",
  null
  
)

export default component.exports